// src/PaperPlaneRightFill.tsx
import * as React from "react";
var PaperPlaneRightFill = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M3 13.19c0 .25.26.43.49.33l13.4-5.36c.15-.06.15-.27 0-.33L3.49 2.48c-.23-.1-.49.07-.49.33V6.1c0 .36.27.67.63.71L13.22 8 3.63 9.19c-.36.05-.63.35-.63.71v3.29z" })
);
PaperPlaneRightFill.displayName = "PaperPlaneRightFill";
export {
  PaperPlaneRightFill
};
